module.exports = __webpack_public_path__ + "img/Journalism.83c9de47.png";